import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

const ButtonStyles = styled.div`
  a {
    box-sizing: border-box;
    display: inline-block;
    height: 48px;
    border-radius: 100px;
    outline: none;
    font-family: moderat-regular;
    font-weight: normal !important;
    font-size: 18px;
    line-height: 47px;
    cursor: pointer;
    padding: 0 40px;
    line-height: 44px;
    transition: 0.2s all ease;
  }
`;

const PillButton = ({
  targetUrl,
  buttonText,
  buttonBgColor,
  buttonBorderColor,
  buttonFontColor,
  buttonHoverBg,
  buttonHoverFont,
  id,
}) => {
  const style = {
    color: buttonFontColor,
    background: buttonBgColor,
    border: `1.5px solid ${buttonBorderColor || "transparent"}`,
  };

  return (
    <ButtonStyles>
      <Link style={style} id={id || ""} to={targetUrl}>
        {buttonText}
      </Link>
    </ButtonStyles>
  );
};

export default PillButton;
